import React from 'react';

import TextBox from '@components/TextBox/TextBox';
import Disclaimer from '@components/Experiences/Disclaimer/Disclaimer';

const BackgroundTextBox = props => {
  let styles = {};
  let pageContent = '';

  let disclaimerStyle = {};
  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.background = `url(${props.backgroundImage})`;
    styles.backgroundSize = 'auto 100%';
    styles.backgroundPosition = 'center center';
    const propsMobile = { ...props };
    propsMobile.style = { marginTop: '6rem', marginBottom: '4rem' };

    pageContent = (
      <div className={'position-relative align-items-center container-fluid'}>
        <TextBox {...propsMobile} />
      </div>
    );
    disclaimerStyle.padding = '2rem 1rem 3rem';
    disclaimerStyle.backgroundColor = 'rgba(255, 255, 255, 0.7)';
  } else {
    styles.height = props.screenHeight + 'px';
    pageContent = (
      <div
        className={
          'ml-5 pl-5 abs-container d-flex align-items-center container-fluid'
        }
      >
        <TextBox {...props} />
      </div>
    );

    disclaimerStyle.position = 'absolute';
    disclaimerStyle.width = '100%';
    disclaimerStyle.maxWidth = 'initial';
    disclaimerStyle.bottom = '0px';
    disclaimerStyle.left = '0px';
    disclaimerStyle.padding = '1rem 1rem 3rem';
    disclaimerStyle.backgroundColor = 'rgba(255, 255, 255, 0.7)';
  }
  return (
    <div id={props.id} className={props.className} style={styles}>
      <img
        src={props.backgroundImage}
        alt={'JetSuite'}
        className={'img-fluid d-none d-lg-block img-mobile-background'}
      />
      {pageContent}
      <div
        className={'position-absolute w-100 d-none d-md-block'}
        style={{ top: '0px', left: '0px' }}
      >
        <video id="background-video" loop autoPlay muted className={'w-100'}>
          <source
            src={
              'https://d15vuanl9987q0.cloudfront.net/js-destinations-video-background-720p.mp4'
            }
            type="video/mp4"
          />
          <source
            src={
              'https://d15vuanl9987q0.cloudfront.net/js-destinations-video-background-720p.mp4'
            }
            type="video/ogg"
          />
        </video>
      </div>

      <Disclaimer
        style={disclaimerStyle}
        classNAme={'w-100'}
        styleContent={{
          width: '100%',
          maxWidth: 'initial',
          padding: '0rem 2rem',
          flex: 'initial'
        }}
      />
    </div>
  );
};

export default BackgroundTextBox;



// WEBPACK FOOTER //
// ./src/components/BackgroundTextBox/BackgroundTextBox.js